(function () {
  var DRAG_THRESHOLD = 6;
  var RESUME_DELAY = 900;
  var TOUCH_RESUME_DELAY = 1800;
  var DESKTOP_SPEED = 26;
  var MOBILE_SPEED = 18;
  var MOBILE_STEP_DELAY = 2800;

  function getSpeed() {
    return window.matchMedia('(max-width: 767px)').matches ? MOBILE_SPEED : DESKTOP_SPEED;
  }

  function isMobile() {
    return window.matchMedia('(max-width: 767px)').matches;
  }

  function makeClone(card) {
    var clone = card.cloneNode(true);
    clone.classList.add('is-marquee-clone');
    clone.setAttribute('aria-hidden', 'true');
    clone.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach(function (node) {
      node.setAttribute('tabindex', '-1');
    });
    return clone;
  }

  function initCarousel(track) {
    if (!track || track.dataset.yiumeCarouselReady === 'true') return;

    var originalCards = Array.prototype.slice.call(track.querySelectorAll('.yiume-sale-card'));
    var viewport = track.closest ? track.closest('.yiume-sale-viewport') : null;
    var navButtons = viewport ? Array.prototype.slice.call(viewport.querySelectorAll('[data-yiume-sale-nav]')) : [];

    if (originalCards.length < 2) {
      navButtons.forEach(function (button) {
        button.style.display = 'none';
      });
      return;
    }

    track.dataset.yiumeCarouselReady = 'true';

    var before = document.createDocumentFragment();
    var after = document.createDocumentFragment();

    originalCards.forEach(function (card) {
      before.appendChild(makeClone(card));
      after.appendChild(makeClone(card));
    });

    track.insertBefore(before, originalCards[0]);
    track.appendChild(after);

    var segmentWidth = 0;
    var pointerId = null;
    var startX = 0;
    var startScroll = 0;
    var dragged = false;
    var suppressClick = false;
    var paused = false;
    var resumeTimer = null;
    var lastTickTime = Date.now();
    var lastMobileStepTime = Date.now();
    var autoScrollPosition = 0;

    function measure() {
      segmentWidth = track.scrollWidth / 3;
      if (segmentWidth > 0 && (track.scrollLeft < 1 || track.scrollLeft > segmentWidth * 2)) {
        track.scrollLeft = segmentWidth;
      }
      autoScrollPosition = track.scrollLeft;
      lastMobileStepTime = Date.now();
    }

    function normalizePosition() {
      if (!segmentWidth) return;
      if (track.scrollLeft >= segmentWidth * 2) {
        track.scrollLeft -= segmentWidth;
      } else if (track.scrollLeft <= 0) {
        track.scrollLeft += segmentWidth;
      }
      autoScrollPosition = track.scrollLeft;
    }

    function setPaused(nextPaused) {
      paused = nextPaused;
      track.classList.toggle('is-marquee-paused', paused);
    }

    function pause() {
      clearTimeout(resumeTimer);
      setPaused(true);
    }

    function resumeSoon(delay) {
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(function () {
        lastTickTime = Date.now();
        lastMobileStepTime = Date.now();
        setPaused(false);
      }, delay || RESUME_DELAY);
    }

    function getCardWidth() {
      var card = track.querySelector('.yiume-sale-card:not(.is-marquee-clone)');
      return card ? card.getBoundingClientRect().width : 0;
    }

    function snapToNearestCard() {
      if (!isMobile()) return;
      var cardWidth = getCardWidth();
      if (!cardWidth) return;
      autoScrollPosition = Math.round(track.scrollLeft / cardWidth) * cardWidth;
      if (track.scrollTo) {
        track.scrollTo({ left: autoScrollPosition, behavior: 'smooth' });
      } else {
        track.scrollLeft = autoScrollPosition;
      }
      window.setTimeout(normalizePosition, 360);
    }

    function getBatchDistance() {
      var cardWidth = getCardWidth();
      if (!cardWidth) return track.clientWidth * 0.78;

      var visibleCards = Math.max(1, Math.floor(track.clientWidth / cardWidth) - 1);
      return cardWidth * visibleCards;
    }

    function scrollBatch(direction) {
      pause();
      var distance = direction * getBatchDistance();
      autoScrollPosition = track.scrollLeft + distance;
      if (track.scrollBy) {
        track.scrollBy({ left: distance, behavior: 'smooth' });
      } else {
        track.scrollLeft = autoScrollPosition;
      }
      window.setTimeout(normalizePosition, 360);
      resumeSoon(1400);
    }

    function tick() {
      var now = Date.now();
      var delta = Math.min(now - lastTickTime, 64);
      lastTickTime = now;

      if (!paused && !dragged) {
        if (isMobile()) {
          if (now - lastMobileStepTime >= MOBILE_STEP_DELAY) {
            var cardWidth = getCardWidth();
            if (cardWidth) {
              autoScrollPosition = track.scrollLeft + cardWidth;
              if (track.scrollTo) {
                track.scrollTo({ left: autoScrollPosition, behavior: 'smooth' });
              } else {
                track.scrollLeft = autoScrollPosition;
              }
              window.setTimeout(normalizePosition, 420);
            }
            lastMobileStepTime = now;
          }
          return;
        }
        autoScrollPosition += getSpeed() * (delta / 1000);
        track.scrollLeft = autoScrollPosition;
        normalizePosition();
      }
    }

    function leaveIfOutside(event) {
      if (event.relatedTarget && track.contains(event.relatedTarget)) return;
      if (pointerId === null) resumeSoon();
    }

    track.addEventListener('mouseenter', pause);
    track.addEventListener('mouseleave', leaveIfOutside);
    track.addEventListener('pointerenter', pause);
    track.addEventListener('pointerleave', leaveIfOutside);
    track.addEventListener('mouseover', pause);
    track.addEventListener('mouseout', leaveIfOutside);
    track.addEventListener('focusin', pause);
    track.addEventListener('focusout', function () {
      resumeSoon();
    });

    track.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      pointerId = event.pointerId;
      startX = event.clientX;
      startScroll = track.scrollLeft;
      dragged = false;
      pause();
    });

    track.addEventListener('pointermove', function (event) {
      if (pointerId !== event.pointerId) return;
      var distance = event.clientX - startX;

      if (Math.abs(distance) > DRAG_THRESHOLD && !dragged) {
        dragged = true;
        track.classList.add('is-dragging');
        if (track.setPointerCapture) track.setPointerCapture(pointerId);
      }

      if (!dragged) return;
      autoScrollPosition = startScroll - distance;
      track.scrollLeft = autoScrollPosition;
      normalizePosition();
    });

    function stopDragging(event) {
      if (pointerId !== event.pointerId) return;
      var wasDragged = dragged;
      track.classList.remove('is-dragging');
      if (track.hasPointerCapture && track.hasPointerCapture(pointerId)) {
        track.releasePointerCapture(pointerId);
      }
      pointerId = null;
      dragged = false;
      if (wasDragged) {
        suppressClick = true;
        window.setTimeout(function () {
          suppressClick = false;
        }, 250);
      }
      if (wasDragged && isMobile()) {
        snapToNearestCard();
      } else {
        normalizePosition();
      }
      resumeSoon(wasDragged || event.pointerType === 'touch' ? TOUCH_RESUME_DELAY : RESUME_DELAY);
    }

    track.addEventListener('pointerup', stopDragging);
    track.addEventListener('pointercancel', stopDragging);
    track.addEventListener('touchstart', function () {
      pause();
    }, { passive: true });
    track.addEventListener('touchend', function () {
      snapToNearestCard();
      resumeSoon(TOUCH_RESUME_DELAY);
    }, { passive: true });
    track.addEventListener('scroll', function () {
      if (pointerId !== null) return;
      if (Math.abs(track.scrollLeft - autoScrollPosition) > 2) {
        autoScrollPosition = track.scrollLeft;
      }
      normalizePosition();
    }, { passive: true });
    track.addEventListener('click', function (event) {
      if (!suppressClick) return;
      event.preventDefault();
      event.stopPropagation();
      suppressClick = false;
    }, true);

    track.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      scrollBatch(event.key === 'ArrowRight' ? 1 : -1);
    });

    navButtons.forEach(function (button) {
      var direction = button.getAttribute('data-yiume-sale-nav') === 'prev' ? -1 : 1;

      button.addEventListener('click', function (event) {
        event.preventDefault();
        scrollBatch(direction);
      });

      button.addEventListener('mouseenter', pause);
      button.addEventListener('mouseleave', function () {
        resumeSoon();
      });
      button.addEventListener('focus', pause);
      button.addEventListener('blur', function () {
        resumeSoon();
      });
    });

    window.addEventListener('resize', function () {
      measure();
      normalizePosition();
    });

    measure();
    window.requestAnimationFrame(function () {
      measure();
      lastTickTime = Date.now();
      window.setInterval(tick, 33);
    });
  }

  function init() {
    document.querySelectorAll('[data-yiume-sale-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
